<template>
  <transition name="fade" mode="out-in">
    <div class="dkl-popup" :style="{'top': top, 'left': left}" v-show="show">
      <div class="card flex-fill" style="margin-bottom: 10px!important; border-radius: 20px">
        <div class="card-header dkl-tooltip-header" :style="{'background-color': currentObject.headerColor, 'border-top-left-radius': '20px', 'border-top-right-radius': '20px'}">
          <h5 class="dkl-tooltip-title mb-0" style="max-width: 180px">{{ currentObject.title }}</h5>
          <div class="btn-group" style="min-width: 160px; position: absolute!important; right:10px; display: contents">
            <button type="button" class="btn btn-sm" @click="editObject" data-toggle="tooltip" title="" data-original-title="edit"> <i class="fa fa-pencil"></i></button>
            <button type="button" class="btn btn-sm" @click="deleteObject" data-toggle="tooltip" title="" data-original-title="Delete"> <i class="fa fa-trash-o"></i></button>
            <button type="button" class="btn btn-sm" @click="prevObject" data-toggle="tooltip" title="" data-original-title="prev" :class="{'disabled': currentIndex===0}"> <i class="fa fa-arrow-left"></i></button>
            <button type="button" class="btn btn-sm" @click="nextObject" data-toggle="tooltip" title="" data-original-title="next" :class="{'disabled': popupObjects.length === 0 ||currentIndex===popupObjects.length-1}"> <i class="fa fa-arrow-right"></i></button>
            <button type="button" class="btn btn-sm" @click="show=false" data-toggle="tooltip" title="" data-original-title="close"> <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="card-body dkl-tooltip-info">
          <p class="dkl-tooltip-text">{{ currentObject.description }}</p>
          <p class="card-text">Umzusetzen bis/Ziel: {{ currentObject.due_date }}</p>
          <p class="card-text">Verantwortlicher: {{ currentObject.assigned_to_char }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {objectModalName, PRIORITY, STATUS} from "@/utils/enums";
import {modelTypes} from "@/utils";

export default {
      name: "DKLPopup",

      props: {
        title: {
          type: String,
          default: ''
        },
        show: {
          type: Boolean,
          default: false
        },
        popupObjects: {
          type: Array,
          required: true
        },
        width: String,
        resetList: {
          type: Boolean,
          default: false
        },
        customClass: {
          type: String,
          default: ''
        },
        top: {
          type: String,
          default: '50px'
        },
        left: {
          type: String,
          default: '50px'
        },
        headerColor: {
          type: String,
          default: '#ffffff80'
        }
      },
      data() {
        return {
          currentIndex: 0
        }
      },
      watch: {
        show(newVal) {
          if (!newVal) this.currentIndex = 0
        }
      },
      mounted() {
      },
      computed: {
        style() {
          let style = {};
          if (!this.fullscreen) {
            style.marginTop = this.top;
            if (this.width) {
              style.width = this.width;
            }
          }
          return style;
        },
        currentObject() {
          return this.popupObjects.length === 0 ? null : this.popupObjects[this.currentIndex]
        }
      },
      methods: {
        prevObject() {
          if (this.currentIndex === 0) return
          this.currentIndex -= 1
        },
        nextObject() {
          if (this.popupObjects.length - 1 === this.currentIndex) return
          this.currentIndex += 1
        },
        editObject() {
          if (this.currentObject) this.$emit('editObject', this.currentObject.id)
        },
        deleteObject() {
          if (this.currentObject) this.$emit('deleteObject', this.currentObject)
        },
      }
    }
</script>

<style scoped>
  .dkl-popup {
    position: fixed;
    width: 350px;
    height: 260px;
    font-size: 15px;
    font-weight: 600;
  }

  .dkl-tooltip-header {
    padding: 12px 16px;
    color: #eee;
    display: flex;
  }

  .dkl-tooltip-info {
    padding: 16px 16px 60px 16px;
    position: relative;
    line-height: 32px;
  }

  .dkl-tooltip-title {
    font-weight: 600;
    line-height: 30px;
  }

  .dkl-tooltip-text {
    color: black!important;
    font-size: 14px!important;
  }

  .fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-enter-from,
  .fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }
</style>
